var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 75,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    clipRule: "evenodd",
    fill: "red",
    fillRule: "evenodd",
    d: "m31.59394,40.85322c6.08,-3.75831 12.57,-7.05598 18.96,-10.00819c4.59,15.55666 4.17,28.33909 -4.35,36.50476c-5.52,4.09331 -10.57,6.52207 -15.1,7.1502l-4.81,-0.05234c-0.61,-0.10469 -1.22,-0.25125 -1.81,-0.43969c-9.09,-2.88939 -8.23,-11.53664 -4.8,-19.24169c3.35,-7.51661 5.42,-9.89303 11.91,-13.91306l0,0zm11.71,-26.70595c-1.33,-4.31315 -3.94,-6.38598 -7.84,-8.43787c2.82,-1.32954 5.22,-3.88393 7.57,-1.35048c2.34,2.51252 0.88,7.32817 0.27,9.78834l0,0zm-14.58,-2.94174c2.33,-5.43332 10.87,0.3036 10.66,5.09831l-0.08,1.7797c-1.82,0.15703 -3.58,0.12563 -5.4,-0.06281c-4.62,-0.48157 -7.77,-0.75375 -5.18,-6.8152l0,0zm-19.77,-5.59035c-0.71,2.19845 -0.82,4.08284 -0.37,6.28129c1.11,5.3391 6.14,9.95584 10.32,12.85571c2.22,1.53892 4.57,2.74283 7.07,3.53846l7.97,0.05234l-11.78,13.82931c-0.4,-2.42877 -1.4,-4.60628 -2.62,-6.72098c-3.49,-6.04051 -8.03,-8.10286 -12.21,-10.93991c-9.84,-6.66864 -10.24,-13.47337 1.62,-18.89621l0,0zm14.68,8.2913c2.2,-7.19208 5.99,-11.0132 11.89,-13.21165c-8.26,-2.7533 -17.57,3.8944 -11.89,13.21165l0,0zm-4.45,-13.26399c-5.4,14.19572 3.34,20.12107 19.86,21.48201c-2.87,1.1411 -5.69,1.67501 -8.46,1.62267c-4.83,-0.08375 -12,-2.46017 -15.08,-6.54301c-4.38,-5.83113 -4.75,-15.13791 3.68,-16.56167l0,0zm25.82,27.98315c9.53,-6.39645 20.03,-21.93217 2.99,-23.8689c9.45,11.5157 -31.97,43.31996 -2.99,23.8689l0,0zm-40.06,5.60082c0.42,-1.92626 0.98,-3.82112 1.73,-5.66363c2.47,1.53892 4.72,3.4233 6.66,5.81019c1.62,1.98908 3.04,4.32362 4.19,7.08739c0.64,1.53892 0.9,3.00455 0.75,4.38643c-0.87,7.9563 -7.33,7.4538 -5.16,24.94719c-2.26,-1.4761 -4.35,-3.69549 -6.18,-7.12926c-4.81,-9.066 -4.17,-19.53481 -1.99,-29.43831l0,0z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m0,41.04003",
    opacity: "NaN",
    stroke: "#0000ff",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    d: "m182.49975,104.53994",
    opacity: "NaN",
    stroke: "#0000ff",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.e560e638f3addfc77be69949c1be8cf8.svg";
export { ForwardRef as ReactComponent };